import { MapPoint } from '../../../map-display';

export const MapDisplayInfoService = Symbol('MapDisplayInfoService');

export interface MapDisplayInfoService {
  getMapCenter(): MapPoint | undefined;
  setMapCenter(newCenter: MapPoint): void;
  getMapZoom(): number | undefined;
}
